import React from 'react';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import { flowType } from '@utility/userInfo';
import { APP_CONFIG } from '@constants';
import style from '../../PaymentScreens/paymentScreens.module.scss';
import { TouchableButton } from '../../common/Touchable/index';
import { getObjectValue } from "@utility/utills";
import { safeJsonParse } from '../../../utility/helperFunction';

const StartScreenPortrait = ({ PaymentPageBtn, serverAppTheme, onClearSplit, ...props}) => {
    const buttonControl = getObjectValue(() => safeJsonParse(window.sessionStorage.getItem('seat'))?.control, {});
    const payAnAmountBtn = PaymentPageBtn.find((btn) => { return btn?.name === 'Pay Full Check' });
    const handleRouteBack = () => {
        props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, { replace: true });
    }
    const displayOrder = [1, 2, 0, 3];

    return (
        <div className={cn("col-12 d-flex pr-0 px-0 ")}>
            {buttonControl?.enableOtherPaymentOptions &&
                <div
                    className={cn('col-12 p-0')}
                >
                    <TouchableButton
                        style={{ height: '3.9375rem', fontSize: '1.35rem', fontWeight: 600, background: !buttonControl?.enableOtherPaymentOptions ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: !buttonControl?.enableOtherPaymentOptions ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                        className={cn('col-12 btn my-1 px-0 btn-ripple fw-600')}
                        disabled={!buttonControl?.enableOtherPaymentOptions}
                    >
                        {LABEL().OTHER_PAYMENT_OPTIONS}
                    </TouchableButton>
                </div>
            }
            <div
                className={cn('col-4 pl-0 pr-1')}
            >
                <TouchableButton
                    style={{fontSize: '1.25rem', fontWeight: 600, background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
                    className={cn('col-12 btn68 mb-2 px-0 btn-ripple fw-600')}
                    onClick={() => {handleRouteBack()}}
                    rippleEffect={true}
                >
                    {LABEL().LS_BACK}
                </TouchableButton>
                <TouchableButton
                    style={{ fontSize: '1.25rem', fontWeight: 600, background: !buttonControl?.enableClearSplits ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: !buttonControl?.enableClearSplits ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                    className={cn('col-12 btn68 px-1 btn-ripple fw-600',
                    )}
                    onClick={() => onClearSplit()}
                    disabled={!buttonControl?.enableClearSplits}
                    rippleEffect={true}
                >
                    {LABEL().LS_CLEAR_SPLITS}
                </TouchableButton>
            </div>
            <div className={cn('col-8 px-0')}>
    <div className={cn('row mx-0')}>
        {displayOrder.map((i) => {
            const item = PaymentPageBtn[i];

            return (
                item?.name !== 'Pay Full Check' && (
                    <div key={item.name} className={cn('col-6 mb-2', [2,3].includes(displayOrder) ? 'pr-0 pl-1' : 'px-1')}>
                        <TouchableButton
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                if (!item.disabled) {
                                    item.click();
                                }
                            }}
                            style={{
                                background: item.disabled
                                    ? serverAppTheme?.secondaryBtnDisabled
                                    : serverAppTheme?.secondaryBtn,
                                color: item.disabled
                                    ? serverAppTheme?.btn_font_color_disabled
                                    : serverAppTheme?.btn_font_color
                            }}
                            className={cn(
                                'col-12  btn68 btn-ripple fw-600 px-0'
                            )}
                            disabled={item?.disabled}
                            rippleEffect={true}
                        >
                            <div
                                className={cn(style.divForPayment)}
                                style={{ fontSize: '1.15rem', fontWeight: 600 }}
                            >
                                {item.name}
                            </div>
                        </TouchableButton>
                    </div>
                )
            );
        })}
        {payAnAmountBtn !== undefined &&
                <div className='col-6 px-0'>
                    <TouchableButton
                        key={payAnAmountBtn.name}
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            payAnAmountBtn.click();
                        }}
                        style={{ background: payAnAmountBtn.disabled ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: payAnAmountBtn.disabled ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                        className={cn(
                            'col-12 btn68 my-0 px-1 btn-ripple',
                        )}
                        disabled={payAnAmountBtn.disabled}
                    >
                        <div
                            className={cn('fw-600', style.divForPayment)}
                            style={{
                                fontSize: '1.15rem',
                            }}
                        >
                            {payAnAmountBtn.name}
                        </div>
                    </TouchableButton>
                </div>
            }
    </div>
</div>

            {/* {payAnAmountBtn !== undefined &&
                <div className='col-6 px-0'>
                    <TouchableButton
                        key={payAnAmountBtn.name}
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            payAnAmountBtn.click();
                        }}
                        style={{ height: '3.9375rem', fontWeight: 600, background: payAnAmountBtn.disabled ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: payAnAmountBtn.disabled ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                        className={cn(
                            'col-12 btn my-1 px-1 btn-ripple',
                        )}
                        disabled={payAnAmountBtn.disabled}
                    >
                        <div
                            className={cn('fs-18 fw-600', style.divForPayment)}
                            style={{
                                fontSize: '1.35rem',
                            }}
                        >
                            {payAnAmountBtn.name}
                        </div>
                    </TouchableButton>
                </div>
            } */}
        </div>
    );
};

export default StartScreenPortrait;